import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import StudentRules from "./StudentRules";
import { Container, Typography } from "@mui/material";
import GeneralRules from "./GeneralRules";
import { Link } from "react-router-dom";
import { APP_PATH } from "../../constant";
import Header from "../../GeneralComponents/Header/Header";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function InstitutRules() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      <Box sx={{ width: "100%" }}>
        <Header title="Règlement interieur" />
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          {" "}
          <Tabs value={value} onChange={handleChange} aria-label="Rules tabs">
            <Tab label="Comportement" {...a11yProps(0)} />
            <Tab label="Paiement et règles generales" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <StudentRules />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <GeneralRules />
        </CustomTabPanel>

        <Container maxWidth="lg">
          <Typography variant="h5" gutterBottom>
            Des questions concernant le règlement ?
          </Typography>
          <Typography variant="body1">
            N'hésitez pas à nous contacter pour toute question ou clarification
            concernant ces règles en cliquant{" "}
            <Link to={APP_PATH.CONTACT}>ici</Link>.
          </Typography>
        </Container>
      </Box>
    </Container>
  );
}
